module.exports = "/images/vendor/flag-icon-css/flags/1x1/gl.svg?48bf3e4e3fdafc0726ec49c2c0019d35";